import { Controller } from "@hotwired/stimulus";

const parameterize = function (str1) {
  // Trim leading and trailing whitespace, convert to lowercase, and replace non-alphanumeric characters with an empty string
  return str1
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 -]/g, "")
    .replace(/\s/g, "-");
};

// Connects to data-controller="create-event"
export default class extends Controller {
  static targets = [
    "editLink",
    "titleInput",
    "slug",
    "currencyInput",
    "currencySymbol",
    "taxRateSelect",
    "timeZoneSelect",
    "timeZoneName",
    "endField",
    "endOverlay",
  ];

  connect() {
    this.syncCurrency();
    this.renderTimeZoneName();
  }

  showEnd() {
    if (this.hasEndOverlayTarget) this.endOverlayTarget.hidden = true;
    if (this.hasEndFieldTarget) {
      this.endFieldTarget.querySelector('input[type="text"]')?.focus();
    }
  }

  renderTimeZoneName() {
    if (!this.hasTimeZoneSelectTarget) return;
    const option = this.timeZoneSelectTarget.selectedOptions[0];
    if (!option) return;
    // Strip the "(GMT±00:00) " prefix the select shows, leaving the zone name
    const name = option.text.replace(/^\(.*?\)\s*/, "");
    this.timeZoneNameTargets.forEach((el) => (el.textContent = name));
  }

  setSlug() {
    const slug = parameterize(this.titleInputTarget.value);
    const url = new URL(this.editLinkTarget.href);
    url.searchParams.set("slug", slug);
    this.editLinkTarget.href = url.toString();
    this.slugTarget.innerText = slug;
  }

  syncCurrency() {
    if (!this.hasCurrencyInputTarget) return;
    const option = this.currencyInputTarget.selectedOptions[0];
    if (!option) return;
    const symbol = option.dataset.symbol || option.value;
    this.currencySymbolTargets.forEach((el) => (el.textContent = symbol));
  }

  focusNewTicket() {
    const rows = this.element.querySelectorAll(".ticket-fields");
    const name = rows[rows.length - 1]?.querySelector(
      '[data-ticket-row-target="name"]',
    );
    if (name) name.focus();
  }

  rememberTaxSelect(event) {
    const item = event.target.closest(".ticket-fields");
    this.activeTaxRateSelect =
      item?.querySelector('[data-create-event-target="taxRateSelect"]') ||
      this.taxRateSelectTargets[0];
  }

  attachTaxRate(event) {
    if (!this.hasTaxRateSelectTarget) return;
    const { tax_rate_id, tax_rate_label } = event.detail;
    if (!tax_rate_id) return;

    this.taxRateSelectTargets.forEach((select) => {
      let option = select.querySelector(`option[value="${tax_rate_id}"]`);
      if (!option && tax_rate_label) {
        option = document.createElement("option");
        option.value = tax_rate_id;
        option.textContent = tax_rate_label;
        select.appendChild(option);
      }
    });

    const target = this.activeTaxRateSelect || this.taxRateSelectTargets[0];
    if (target) target.value = tax_rate_id;
  }
}
